import React, { Component } from 'react';


import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import * as actions from './../../../../Actions/Dashboard';


import * as Fenomenes from './../../../../constants/icons/fenomenes/Fenomenes';
import * as Thiefts from './../../../../constants/icons/fenomenes/hurtos/Hurtos';

import domtoimage from 'dom-to-image';

import Grid from '@material-ui/core/Grid';

// import SvgIcon from '@material-ui/core/SvgIcon';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import MenuList from '@material-ui/core/MenuList';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DownloadIcon from '@material-ui/icons/GetApp';
import PaintIcon from '@material-ui/icons/FormatPaint';
import AppsIcon from '@material-ui/icons/Apps';
import ChartIcon from '@material-ui/icons/BarChart';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import TimeLine from '@material-ui/icons/Timeline';
import AddChart from '@material-ui/icons/BarChart';

import Select from '@material-ui/core/Select';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { DOUGHNUT_DASHBOARD_CONTAINER } from './../../../../constants/strings/StringsDashboard';

import './style.css'

class ChartMenu extends Component {
  state = {
    anchorEl: null,
    openDialog: false,
    color: 'Policromático'
  };

  getIcon = (fenomene, color) => {
    switch (fenomene) {
      case 'Homicidios': return Fenomenes.HOMICIDIOS(color);
      case 'Lesiones Personales': return Fenomenes.LESIONES_PERSONALES(color);
      case 'Extorsión': return Fenomenes.EXTORSION(color);
      case 'Capturas': return Fenomenes.CAPTURAS(color);
      case 'Recuperaciones Automotores': return Fenomenes.RECUPERACION_VEHICULOS(color);
      case 'Recuperaciones Motocicletas': return Fenomenes.RECUPERACION_MOTOS(color);
      case 'Incautaciones armas de fuego': return Fenomenes.INCAUTACIONES_ARMAS(color);
      case 'Hurto Automotores': return Thiefts.HURTO_VEHICULO(color);
      case 'Hurto Abigeato': return Thiefts.HURTO_ABIGETAO(color);
      case 'Hurto a Residencias': return Thiefts.HURTO_VIVIENDA(color);
      case 'Hurto Piratería Terrestre': return Thiefts.HURTO_PIRATERIA(color);
      case 'Hurto a Personas': return Thiefts.HURTO_PERSONA(color);
      case 'Hurto Motocicletas': return Thiefts.HURTO_MOTO(color);
      case 'Hurto a Comercio': return Thiefts.HURTO_COMERCIO(color);
      case 'Hurto a Bancos': return Thiefts.HURTO_BANCOS(color);

      default: return '';
    }
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleClickOption1 = () => {
    this.setState({ anchorEl: null });
    this.props.openDialog(this.props.file, this.props.graph);
  }

  handleClickOption2 = () => {
    this.setState({ anchorEl: null });

    var node = document.getElementById(this.props.graph);
    node.classList.add('animate-insert');
    var remove = node.childNodes[0].childNodes[1];
    remove.parentElement.removeChild(remove);
    domtoimage.toPng(node)
      .then((dataUrl) => {
        node.childNodes[0].appendChild(remove);
        this.props.actions.accumulateGraphics(dataUrl, 'img', node.offsetWidth, node.offsetHeight);
      });
    setTimeout(() => {
      node.classList.remove('animate-insert');
    }, 700);

  }

  handleClickOption3 = () => {
    // this.props.actions.deaccumulateGraphics(0);
    var node = document.getElementById(this.props.graph);
    var remove = node.childNodes[0].childNodes[1];
    node.classList.add('background-download-text');
    remove.parentElement.removeChild(remove);
    var file = this.props.file;
    domtoimage.toBlob(node)
      .then(function (blob) {
        node.childNodes[0].appendChild(remove);
        node.classList.remove('background-download-text');
        window.saveAs(blob, file + '.png');
      });
    this.setState({ anchorEl: null });

  }
  handleClickOption4 = () => {
    this.props.onChangeGraph()
    this.setState({ anchorEl: null });
  }
  handleClickOption5 = () => {
    this.setState({ anchorEl: null, openDialog: true });
  }
  handleClickOption6 = () => {
    this.props.changeRate()
    this.setState({ anchorEl: null });
  }

  handleClickOption7 = () => {
    console.log(this.props)
    this.setState({ anchorEl: null });
    this.props.openDialog(this.props.file, this.props.graph, true);
  }

  verMas = () => {
    if (this.props.seeMore !== false) {
      return (
        <MenuItem onClick={this.handleClickOption1}>
          <ListItemIcon >
            <RemoveRedEyeIcon />
          </ListItemIcon>
          <ListItemText inset primary={DOUGHNUT_DASHBOARD_CONTAINER.WATCH_MORE} />
        </MenuItem>
      )
    }
  }
  verTasa = () => {
    if (!!this.props.seeRate) {
      return (
        <MenuItem onClick={this.handleClickOption6}>
          <ListItemIcon >
            <TimeLine />
          </ListItemIcon>
          <ListItemText inset primary={(this.props.dataKey === 'value') ? DOUGHNUT_DASHBOARD_CONTAINER.WATCH_RATE : DOUGHNUT_DASHBOARD_CONTAINER.WATCH_FENOMENE} />
        </MenuItem>
      )
    }
  }
  changeGraph = () => {
    if (this.props.changeGraph === true) {
      return (
        <MenuItem onClick={this.handleClickOption4}>
          <ListItemIcon className='icon-item-menu-custom'>
            <ChartIcon />
          </ListItemIcon>
          <ListItemText inset primary={DOUGHNUT_DASHBOARD_CONTAINER.CHANGE_CHART} className='text-item-menu-custom' />
        </MenuItem>
      )
    }
  }
  changeColor = () => {
    if (this.props.changeColor === true) {
      return (
        <MenuItem onClick={this.handleClickOption5}>
          <ListItemIcon >
            <PaintIcon />
          </ListItemIcon>
          <ListItemText inset primary={DOUGHNUT_DASHBOARD_CONTAINER.COLORS} />
        </MenuItem>
      );
    }
  }
  ver10 = () => {
    if (this.props.seeTen === true) {
      return (
        <MenuItem onClick={this.handleClickOption7}>
          <ListItemIcon >
            <AddChart />
          </ListItemIcon>
          <ListItemText inset primary={DOUGHNUT_DASHBOARD_CONTAINER.WATCH_TEN} />
        </MenuItem>
      );
    }
  }

  handleChangeSelectColor = (event) => {
    console.log('cambio');
    this.setState({ openDialog: false, color: event.target.value })
    this.props.onChangeColor(event.target.value);
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  }
  wathcButtom = () => {
    if (this.props.watch === false) {
      return (
        <Grid item xs={1}></Grid>
      )
    }
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    return (
      <Grid item xs={1} className="client-label" key={'grid-menu-' + this.props.name}>
        <IconButton
          aria-label="More"
          aria-haspopup="true"
          className="client-button-menu no-padding "
          onClick={this.handleClick}
        >
          <MoreHorizIcon className="coleccionar" />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}
          PaperProps={{
            style: {
              maxHeight: 300,
              minHeight: 80, //MAX_HEIGHT DE 48 * 4.5
              maxWidth: 190,
              minWidth: 50
            },
          }}
        >

          <MenuList className="client-menu-options">
            {
              this.verTasa()
            }
            {
              this.verMas()
            }
            {
              this.ver10()
            }
            {
              this.changeGraph()
            }
            {
              this.changeColor()
            }
            {
              !this.props.noHeader &&
              <MenuItem onClick={this.handleClickOption2}>
                <ListItemIcon >
                  <AppsIcon />
                </ListItemIcon>
                <ListItemText inset primary={DOUGHNUT_DASHBOARD_CONTAINER.COLLECT} />
              </MenuItem>
            }
            <MenuItem onClick={this.handleClickOption3}>
              <ListItemIcon >
                <DownloadIcon />
              </ListItemIcon>
              <ListItemText inset primary={DOUGHNUT_DASHBOARD_CONTAINER.DOWNLOAD} />
            </MenuItem>
          </MenuList>
        </Menu>
      </Grid>
    )
  }



  render() {
    return (
      <Grid container style={{ textAlign: 'center', marginTop: '30px' }}>
        <Grid item xs={11} >
          {/* <SvgIcon className="inline-block margin-left-20px font-size-30">
                        {this.getIcon(this.props.title, '#646265')}
                    </SvgIcon> */}
          <h2 className="text-center client-label-second-color inline-block margin-left-20px" style={{ fontSize: '20px' }}>{this.props.title}</h2>
        </Grid>
        {
          this.wathcButtom()
        }
        <Dialog
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}
        >
          <DialogTitle id="form-dialog-title">Cambiar color</DialogTitle>
          <DialogContent>
            <Select
              value={this.state.color}
              onChange={this.handleChangeSelectColor}
            >
              <MenuItem value={'Policromático'}>Policromático</MenuItem>
              <MenuItem value={'Verde'}>Verde</MenuItem>
              <MenuItem value={'Rojo'}>Rojo</MenuItem>
              <MenuItem value={'Verde-Azul'}>Verde-Azul</MenuItem>
              <MenuItem value={'Gris'}>Gris</MenuItem>
              <MenuItem value={'Azul'}>Azul</MenuItem>
              {/* <MenuItem value={30}>Thirty</MenuItem> */}
            </Select>
          </DialogContent>
        </Dialog>
      </Grid>
    )
  }
}

function mapStateToProps(state, props) {
  return {
    noHeader: state.generals.noHeader
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChartMenu);